<template>
  <div class="main-content-wrapper min-vh-100 py-4">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-11 col-xl-10">
          <!-- Glass Card -->
          <div class="detail-card shadow-lg border-0 overflow-hidden">
            <!-- Header Section -->
            <div class="bg-white p-4 border-bottom">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <button type="button" class="btn btn-link text-dark p-0 d-flex align-items-center" @click="goBack" style="text-decoration:none;">
                  <v-icon name="angle-left" scale="1.1" class="mr-2"></v-icon>
                  <span class="font-weight-bold">Volver</span>
                </button>
                <div class="status-badge-container">
                  <span class="badge badge-pill badge-warning px-3 py-2 shadow-sm text-white" v-if="form_update.status_service" style="background-color: #f76e2a;">
                    {{ form_update.status_service.name }}
                  </span>
                </div>
              </div>

              <!-- Main Header Info -->
              <div class="row align-items-center">
                <div class="col-md-7">
                  <!-- Passenger (Representative) Info -->
                  <div class="d-flex align-items-center mb-3 mb-md-0">
                    <div class="avatar-wrapper mr-3 shadow-sm" style="width: 60px; height: 60px;">
                      <img
                        v-if="form_update.children && form_update.children.url_image"
                        :src="form_update.children.url_image"
                        class="img-fluid rounded-circle h-100 w-100"
                        style="object-fit: cover;"
                        alt="Passenger"
                      />
                      <div v-else class="avatar-placeholder rounded-circle bg-light d-flex align-items-center justify-content-center h-100 w-100">
                        <v-icon name="user" scale="1.5" class="text-muted"></v-icon>
                      </div>
                    </div>
                    <div>
                      <h4 class="mb-0 font-weight-bold text-dark">{{ form_update.children ? form_update.children.full_name : 'Pasajero' }}</h4>
                      <div class="d-flex align-items-center mt-1">
                        <span class="badge badge-light px-2 py-1 mr-2 text-muted" style="font-size: 0.75rem;">
                          #{{ form_update.service_code }}
                        </span>
                        <span class="text-muted small font-weight-bold" v-if="form_update.type_route">
                          <v-icon name="random" scale="0.7" class="mr-1" style="color: #f76e2a;"></v-icon>
                          {{ form_update.type_route.name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-5 text-md-right border-left-md mt-3 mt-md-0">
                  <!-- Driver Info -->
                  <div class="d-inline-flex align-items-center text-left">
                    <div class="driver-info mr-3 text-md-right">
                      <p class="mb-0 font-weight-bold text-dark" style="font-size: 0.9rem;">{{ form_update.driver ? form_update.driver.full_name : 'Conductora' }}</p>
                      <p class="text-muted mb-0 small uppercase letter-spacing-1">CONDUCTORA</p>
                    </div>
                    <div class="driver-avatar-container shadow-sm p-1 bg-white rounded-circle" style="width: 50px; height: 50px; border: 2px solid #f76e2a;">
                      <img
                        v-if="form_update.driver && form_update.driver.url_image"
                        :src="form_update.driver.url_image"
                        class="img-fluid rounded-circle h-100 w-100"
                        style="object-fit: cover;"
                        alt="Driver"
                      />
                      <div v-else class="rounded-circle bg-light d-flex align-items-center justify-content-center h-100 w-100">
                        <v-icon name="user-tie" scale="1.1" class="text-muted"></v-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body p-4 p-md-5">
              <!-- Map Controls & Update Info -->
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <div class="d-flex align-items-center mb-2">
                    <div class="live-pulse mr-2"></div>
                    <p class="mb-0 text-muted small font-weight-bold">SEGUIMIENTO EN VIVO</p>
                  </div>
                  <p class="text-secondary small mb-0">
                    Última ubicación: <span class="font-weight-bold text-dark">{{ form_update.latitude_driver }} / {{ form_update.longitude_driver }}</span>
                  </p>
                  <!-- Location History Counter -->
                  <p class="text-secondary small mb-0 mt-1">
                    <v-icon name="map-marked-alt" scale="0.8" class="mr-1"></v-icon>
                    <strong>{{ history.length }}</strong> ubicaciones compartidas
                  </p>
                </div>
                <div class="col-md-6 text-md-right mt-3 mt-md-0">
                  <button
                    type="button"
                    class="btn btn-outline-secondary px-3 mr-2 shadow-sm"
                    @click.prevent="openHistoryModal()"
                    style="border-radius: 20px;"
                    :disabled="history.length === 0"
                  >
                    <v-icon name="map-marked-alt" class="mr-1" scale="0.8"></v-icon>
                    Ver Histórico
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-fill px-4 shadow-sm"
                    @click.prevent="refreshData()"
                    style="border-radius: 20px;"
                  >
                    <v-icon name="sync" class="mr-2" scale="0.8"></v-icon>
                    Actualizar
                  </button>
                </div>
              </div>

              <!-- Map Container -->
              <div class="map-container-wrapper mb-4 shadow-sm">
                <!-- Loading Overlay -->
                <div v-if="!loadedMap" class="map-loading-overlay d-flex flex-column align-items-center justify-content-center">
                  <div class="spinner-border text-primary mb-3" role="status"></div>
                  <p class="text-muted font-weight-bold">Localizando unidad...</p>
                </div>

                <GmapMap
                  v-if="center.lat !== 10"
                  :center="center"
                  :zoom="15"
                  map-type-id="roadmap"
                  :options="mapOptions"
                  class="gmap-responsive"
                  ref="mapRef"
                >
                  <GmapMarker
                    :position="marker.position"
                    :clickable="false"
                    :draggable="false"
                    :icon="marker.icon"
                  />
                  <GmapMarker
                    :position="marker.position_initial"
                    :clickable="false"
                    :draggable="false"
                    :icon="marker.icon_blue"
                  />
                  <GmapMarker
                    :position="marker.position_end"
                    :clickable="false"
                    :draggable="false"
                    :icon="marker.icon_red"
                  />
                </GmapMap>
              </div>

              <!-- Footer Actions -->
              <div class="d-flex justify-content-center mt-5">
                <button
                  type="submit"
                  class="btn btn-outline-primary btn-block py-3 font-weight-bold shadow-sm"
                  @click.prevent="goToMaps(form_update)"
                  style="border-radius: 16px; max-width: 400px;"
                >
                  <v-icon name="map-marked-alt" class="mr-2"></v-icon>
                  Abrir en Google Maps
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- History Modal -->
    <transition name="modal-fade">
      <div v-if="showModal" class="modal-wrapper">
        <div class="modal-backdrop show" @click="closeHistoryModal"></div>
        <div id="historyModal" ref="historyModal" class="modal d-block" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content shadow-lg border-0">
              <div class="modal-header bg-white border-bottom text-dark">
                <h5 class="modal-title d-flex align-items-center">
                  <v-icon name="map-marked-alt" class="mr-2" style="color: #f76e2a;"></v-icon>
                  <strong>Histórico de ubicaciones</strong>
                </h5>
                <button type="button" class="close text-dark" @click="closeHistoryModal">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body p-0">
            <!-- Navigation Controls -->
            <div class="d-flex justify-content-between align-items-center p-3 bg-light border-bottom">
              <button 
                type="button" 
                class="btn btn-outline-primary btn-sm px-3" 
                @click="previousPosition"
                :disabled="position_history === 0"
              >
                <v-icon name="angle-left" scale="0.8"></v-icon>
                Anterior
              </button>
              <div class="text-center">
                <p class="mb-0 font-weight-bold">
                  Ubicación {{ position_history + 1 }} de {{ history.length }}
                </p>
                <small class="text-muted" v-if="history.length > 0 && history[position_history]">
                  {{ formatDate(history[position_history].timestamp) }}
                </small>
              </div>
              <button 
                type="button" 
                class="btn btn-outline-primary btn-sm px-3" 
                @click="nextPosition"
                :disabled="position_history >= history.length - 1"
              >
                Siguiente
                <v-icon name="angle-right" scale="0.8"></v-icon>
              </button>
            </div>

            <!-- History Map -->
            <div style="height: 400px;">
              <GmapMap
                v-if="history.length > 0"
                :center="historyCenter"
                :zoom="14"
                map-type-id="roadmap"
                :options="mapOptions"
                style="width: 100%; height: 100%;"
                ref="historyMapRef"
              >
                <GmapMarker
                  :position="marker_history.position"
                  :clickable="false"
                  :draggable="false"
                  :icon="marker_history.icon"
                />
                <GmapMarker
                  :position="marker.position_initial"
                  :clickable="false"
                  :draggable="false"
                  :icon="marker.icon_blue"
                />
                <GmapMarker
                  :position="marker.position_end"
                  :clickable="false"
                  :draggable="false"
                  :icon="marker.icon_red"
                />
              </GmapMap>
            </div>

            <!-- Legend -->
            <div class="d-flex justify-content-around p-3 bg-light border-top">
              <div class="text-center">
                <span class="badge badge-primary px-2 py-1">●</span>
                <small class="ml-1">Inicio</small>
              </div>
              <div class="text-center">
                <span class="badge badge-dark px-2 py-1">●</span>
                <small class="ml-1">Ubicación Conductora</small>
              </div>
              <div class="text-center">
                <span class="badge badge-danger px-2 py-1">●</span>
                <small class="ml-1">Final</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import { apiPath } from 'src/config'
import Card from 'src/components/Cards/Card.vue'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  components: {
    Card,
    Multiselect
  },
  data() {
    return {
      position_history: 0,
      form_update: {
        id: 0,
        latitude_star: '',
        longitude_star: '',
        latitude_end: '',
        longitude_end: '',
        latitude_driver: '',
        longitude_driver: ''
      },
      marker: { position: { lat: 10, lng: 10 } },
      marker_history: { position: { lat: 10, lng: 10 } },
      center: { lat: 10, lng: 10 },
      historyCenter: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: true
      },
      intervalId: null,
      history: [],
      loadedMap: false,
      showModal: false,
      driverImageError: false,
      customIconUrl: null,
      lastProcessedDriverUrl: null,
      animationId: null,
      currentMarkerPos: null
    }
  },
  computed: {
    google: gmapApi
  },
  watch: {
    google(val) {
      if (val) {
        this.updateMarkers()
      }
    }
  },
  mounted() {
    this.getService()
    this.getAllHistory()
    
    // Auto-refresh every 5 seconds (only service and history)
    this.intervalId = setInterval(() => {
      this.getService()
      this.getAllHistory()
    }, 5000)

    // Move modal to body to avoid rendering issues (not needed with v-if implementation but keeping logic if needed)
  },
  beforeDestroy() {
    // Clear interval
    clearInterval(this.intervalId)
    // Cancel any pending animation
    if (this.animationId) {
      cancelAnimationFrame(this.animationId)
    }
  },
  methods: {
    ...mapActions(['getData']),

    /**
     * Refresh data manually
     */
    refreshData() {
      this.getService()
      this.getAllHistory()
    },

    /**
     * Get service data only (optimized - no profile/selects calls)
     */
    getService() {
      const id = this.$route.params.id
      
      this.getData({
        url: 'service/' + id,
        params: {}
      })
        .then((response) => {
          this.form_update = response.data
          this.updateMarkers()
          this.loadedMap = true
        })
        .catch((error) => {
          console.error('Error fetching service:', error)
        })
    },

    /**
     * Update all map markers safely
     */
    updateMarkers() {
      if (!this.form_update.id) return

      // Set map markers
      this.marker.position_initial = {
        lat: parseFloat(this.form_update.latitude_star),
        lng: parseFloat(this.form_update.longitude_star)
      }
      this.marker.position_end = {
        lat: parseFloat(this.form_update.latitude_end),
        lng: parseFloat(this.form_update.longitude_end)
      }

      // Base icon scaling
      const size = this.google ? new this.google.maps.Size(40, 40) : null

      this.marker.icon_blue = {
        url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        scaledSize: size
      }
      this.marker.icon_red = {
        url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
        scaledSize: size
      }

      // Handle driver icon
      let driverId = this.form_update.driver?.id
      let driverIcon = this.form_update.driver?.url_image
      
      if (!driverIcon) {
        this.customIconUrl = 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
      } else if (driverId !== this.lastProcessedDriverUrl) {
        // Only start processing if it's a new driver/ID
        this.lastProcessedDriverUrl = driverId
        this.createCircularMarker(driverId).then(url => {
          this.customIconUrl = url
          this.applyDriverIcon(url, size)
          this.updateHistoryMarker()
        }).catch(() => {
          this.customIconUrl = driverIcon
          this.applyDriverIcon(driverIcon, size)
        })
      }

      // Set driver position
      this.marker.position = {
        lat: parseFloat(this.form_update.latitude_driver),
        lng: parseFloat(this.form_update.longitude_driver)
      }
      
      // Apply current icon (Base64 if ready, otherwise fallback)
      this.applyDriverIcon(this.customIconUrl || driverIcon || 'https://maps.google.com/mapfiles/ms/icons/green-dot.png', size)

      // Set map center
      this.center = {
        lat: parseFloat(this.form_update.latitude_driver),
        lng: parseFloat(this.form_update.longitude_driver)
      }
    },

    /**
     * Helper to apply driver icon reactively
     */
    applyDriverIcon(url, size) {
      this.marker.icon = {
        url: url,
        scaledSize: size || (this.google ? new this.google.maps.Size(40, 40) : null)
      }
    },

    /**
     * Get location history for the service
     */
    getAllHistory() {
      this.getData({
        url: 'service_history/all',
        params: {
          id_service: this.$route.params.id
        }
      })
        .then((response) => {
          if (response.code === 200 && response.data.locations) {
            this.history = response.data.locations
          }
        })
        .catch((error) => {
          console.error('Error fetching history:', error)
        })
    },

    /**
     * Open history modal and set initial position
     */
    openHistoryModal() {
      if (this.history.length === 0) return
      
      this.position_history = 0
      this.updateHistoryMarker()
      this.showModal = true
    },

    /**
     * Close history modal
     */
    closeHistoryModal() {
      this.showModal = false
    },

    /**
     * Navigate to next position in history
     */
    nextPosition() {
      if (this.position_history < this.history.length - 1) {
        this.position_history++
        this.updateHistoryMarker()
      }
    },

    /**
     * Navigate to previous position in history
     */
    previousPosition() {
      if (this.position_history > 0) {
        this.position_history--
        this.updateHistoryMarker()
      }
    },

    /**
     * Update history marker position based on current index
     */
    updateHistoryMarker() {
      if (this.history.length === 0) return

      const location = this.history[this.position_history]
      const targetLat = parseFloat(location.lat)
      const targetLng = parseFloat(location.lon)

      // Initialize current position if not set
      if (!this.currentMarkerPos) {
        this.currentMarkerPos = {
          lat: targetLat,
          lng: targetLng
        }
        this.marker_history.position = { ...this.currentMarkerPos }
      } else {
        // Smoothly animate to the new position
        this.animateMarkerTo(targetLat, targetLng)
      }

      let driverIcon = this.form_update.driver?.url_image
      
      // If we detected CORS error or missing image, use default
      if (this.driverImageError || !driverIcon) {
        driverIcon = 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
      } else if (this.customIconUrl) {
        driverIcon = this.customIconUrl
      }

      this.marker_history.icon = {
        url: driverIcon,
        scaledSize: this.google ? new this.google.maps.Size(40, 40) : null
      }

      // Update history map center
      this.historyCenter = {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lon)
      }
    },

    /**
     * Format date for display
     */
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY HH:mm:ss')
    },

    /**
     * Create a circular marker icon with an orange border
     * @param {number} userId - User ID
     * @returns {Promise<string>} - Data URL of the custom icon
     */
    async createCircularMarker(userId) {
      if (!userId) return null
      
      try {
        let base64 = null
        const proxyUrl = `${apiPath}/user/image/${userId}`

        // Strategy 1: Fetch through our backend proxy (Avoids CORS)
        try {
          const token = Cookies.get('access_token')
          const response = await fetch(proxyUrl, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
          if (response.ok) {
            const blob = await response.blob()
            base64 = await this.blobToBase64(blob)
          } else {
            throw new Error('Backend proxy returned error: ' + response.status)
          }
        } catch (e) {
          console.warn('Backend image proxy failed:', e)
          return null
        }

        // Now process the Base64 image in Canvas
        return new Promise((resolve) => {
          const img = new Image()
          img.crossOrigin = 'anonymous' // Just in case
          img.onload = () => {
            try {
              const size = 120
              const canvas = document.createElement('canvas')
              canvas.width = size
              canvas.height = size
              const ctx = canvas.getContext('2d')
              const center = size / 2
              const radius = (size / 2) - 5
              const borderWidth = 6

              // Draw orange border circle
              ctx.beginPath()
              ctx.arc(center, center, radius, 0, 2 * Math.PI)
              ctx.fillStyle = '#f76e2a'
              ctx.fill()

              // Draw inner white circle
              ctx.beginPath()
              ctx.arc(center, center, radius - borderWidth, 0, 2 * Math.PI)
              ctx.fillStyle = 'white'
              ctx.fill()

              // Clip for the image
              ctx.save()
              ctx.beginPath()
              ctx.arc(center, center, radius - borderWidth - 4, 0, 2 * Math.PI)
              ctx.clip()

              // Draw image scaled
              ctx.drawImage(img, center - (radius - borderWidth - 4), center - (radius - borderWidth - 4), (radius - borderWidth - 4) * 2, (radius - borderWidth - 4) * 2)
              ctx.restore()

              resolve(canvas.toDataURL())
            } catch (e) {
              console.error('Canvas processing error:', e)
              resolve(url)
            }
          }
          img.onerror = () => resolve(url)
          img.src = base64
        })
      } catch (e) {
        console.warn('CORS/Proxy recovery failed:', e)
        return url
      }
    },

    /**
     * Helper to convert Blob to Base64
     */
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },

    /**
     * Animate history marker smoothly to target coordinates
     */
    animateMarkerTo(targetLat, targetLng) {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId)
      }

      const duration = 500 // ms
      const startLat = this.currentMarkerPos.lat
      const startLng = this.currentMarkerPos.lng
      const startTime = performance.now()

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)

        // Ease out quad
        const easedProgress = progress * (2 - progress)

        this.currentMarkerPos.lat = startLat + (targetLat - startLat) * easedProgress
        this.currentMarkerPos.lng = startLng + (targetLng - startLng) * easedProgress

        this.marker_history.position = {
          lat: this.currentMarkerPos.lat,
          lng: this.currentMarkerPos.lng
        }

        if (progress < 1) {
          this.animationId = requestAnimationFrame(animate)
        } else {
          this.animationId = null
        }
      }

      this.animationId = requestAnimationFrame(animate)
    },

    /**
     * Open driver location in Google Maps with a warning alert
     */
    goToMaps(form_update) {
      Swal.fire({
        title: 'Abrir Google Maps',
        text: 'Podrás ver la última ubicación compartida por la conductora, pero no visualizarás la ruta completa en el mapa externo.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary px-4 shadow-sm',
          cancelButton: 'btn btn-outline-secondary px-4'
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(
            'https://www.google.com/maps/search/?api=1&query=' +
              form_update.latitude_driver +
              ',' +
              form_update.longitude_driver,
            '_blank'
          )
        }
      })
    },

    /**
     * Go back to previous page
     */
    goBack() {
      window.history.go(-1)
    }
  }
}
</script>
<style scoped>
.main-content-wrapper {
  background: #f8faff;
  padding-bottom: 3rem;
}

.detail-card {
  border-radius: 24px;
  background: #ffffff;
}

.avatar-placeholder {
  background: #edf2f7;
  color: #a0aec0;
}

.letter-spacing-1 {
  letter-spacing: 1px;
}

@media (min-width: 768px) {
  .border-left-md {
    border-left: 1px solid #edf2f7;
  }
}

.card-header-gradient {
  background: linear-gradient(90deg, #2c3e50 0%, #4ca1af 100%);
  border-bottom: none;
}

.badge-light-blue {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.uppercase {
  text-transform: uppercase;
}

.live-pulse {
  width: 10px;
  height: 10px;
  background: #f76e2a;
  border-radius: 50%;
  box-shadow: 0 0 0 rgba(247, 110, 42, 0.4);
  animation: pulse 2s infinite;
}

.map-container-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  height: 600px;
  background: #f8faff;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.gmap-responsive {
  width: 100%;
  height: 100%;
}

.map-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
  backdrop-filter: blur(4px);
}

.bg-gradient-primary {
  background: white;
  border-bottom: 1px solid #edf2f7;
}

@keyframes pulse {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(247, 110, 42, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(247, 110, 42, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(247, 110, 42, 0); }
}

/* Modal Manual Styles */
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2001;
}

.modal {
  z-index: 2002;
  overflow-y: auto;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .display-4 { font-size: 2.5rem; }
  .map-container-wrapper { height: 400px; }
}
</style>
